// eslint-disable-next-line import/prefer-default-export
export function capitalize(str = '', multiwords = false) {
  return multiwords
    ? str
        .split(' ')
        .map((word) => word[0]?.toUpperCase() + word.slice(1)?.toLowerCase())
        .join(' ')
    : `${str[0]?.toUpperCase()}${str.slice(1).toLowerCase()}`
}

export function lowercaseFirst(str: string) {
  if (typeof str !== 'string') {
    return ''
  }

  if (str.length === 0) {
    return str
  }

  return str[0].toLowerCase() + str.slice(1)
}

export const capitalizeAndFormat = (str: string, charToRemove: string, charToReplace: string) => {
  return str.trim()[0]?.toUpperCase() + str.slice(1)?.toLowerCase().replace(charToRemove, charToReplace)
}

export const lowercaseAndFormat = (str: string, charToRemove: string, charToReplace: string) => {
  return str.trim()[0]?.toLowerCase() + str.slice(1)?.toLowerCase().replace(charToRemove, charToReplace)
}

export const capitalizeAllWords = (str: string) => {
  if (!str) return ''

  return str
    .trim()
    .split(' ')
    .map((word) => capitalize(word.toLowerCase()))
    .join(' ')
}

export const camelize = (str: string) => {
  return str
    .split(' ')
    .map((word, index) => (index === 0 ? word.toLowerCase() : capitalize(word)))
    .join('')
}

export const hyphensToCamelCase = (str: string) =>
  str.replace(/-([a-z])/g, (g) => {
    return g[1].toUpperCase()
  })

export function getTextWidth(text, font) {
  // re-use canvas object for better performance
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'))
  const context = canvas.getContext('2d')
  context.font = font
  const metrics = context.measureText(text)
  return metrics.width
}

export function getCssStyle(element, prop) {
  return window.getComputedStyle(element, null).getPropertyValue(prop)
}

export function getCanvasFont(el = document.body) {
  const fontWeight = getCssStyle(el, 'font-weight') || 'normal'
  const fontSize = getCssStyle(el, 'font-size') || '16px'
  const fontFamily = getCssStyle(el, 'font-family') || 'Times New Roman'

  return `${fontWeight} ${fontSize} ${fontFamily}`
}

export function doesIncludeSubstring(str: string, substr: string) {
  return str?.toLowerCase().trim().includes(substr?.toLowerCase().trim())
}

export function pluralize(word: string, count: number) {
  return count === 1 ? word : `${word}s`
}
